import LayoutView from "./views/_layout.svelte";
import MainView from "@/views/main/index.svelte";
import ContactView from "@/views/contact/contact.svelte";
import BandiWelcomeView from "@/views/bandiburri/welcome.svelte";
import BandiBrandView from "@/views/bandiburri/brand.svelte";
import BandiHistoryView from "@/views/bandiburri/history.svelte";
import BandiAwardView from "@/views/bandiburri/award.svelte";
import ServiceView from "@/views/service/index.svelte";
import BoardListView from "@/views/board/list.svelte";
import BoardWriteView from "@/views/board/write.svelte";
import BoardDetailView from "@/views/board/detail.svelte";
const routes = [
    {
        id: "root",
        name: "/",
        layout: LayoutView,
        component: MainView,
    },
    {
        id: "bandiburri",
        name: "bandiburri",
        nestedRoutes: [
            {
                name: "welcome",
                label: "인사말",
                component: BandiWelcomeView,
                layout: LayoutView,
            },
            {
                name: "brand",
                label: "브랜드 소개",
                component: BandiBrandView,
                layout: LayoutView,
            },
            {
                name: "history",
                label: "히스토리",
                component: BandiHistoryView,
                layout: LayoutView,
            },
            {
                name: "awarded",
                label: "인증 및 수상내역",
                component: BandiAwardView,
                layout: LayoutView,
            },
        ],
    },
    {
        id: "service",
        name: "service",
        nestedRoutes: [
            {
                name: "product",
                label: "제품소개",
                component: ServiceView,
                layout: LayoutView,
            },
            {
                name: "consult",
                label: "교육",
                component: ServiceView,
                layout: LayoutView,
            },
            {
                name: "management",
                label: "관리시스템",
                component: ServiceView,
                layout: LayoutView,
            },
            {
                name: "development",
                label: "연구/개발",
                component: ServiceView,
                layout: LayoutView,
            },
        ],
    },
    {
        id: "contact",
        name: "contact",
        label: "문의하기",
        component: ContactView,
        layout: LayoutView,
    },
    {
        id: "board",
        name: "board",
        visible: false,
        nestedRoutes: [
            {
                id: "list",
                name: "list/:code/:category",
                component: BoardListView,
                layout: LayoutView,
            },
            {
                id: "write",
                name: "write/:code/:category",
                component: BoardWriteView,
                layout: LayoutView,
            },
            {
                id: "detail",
                name: "detail/:id",
                component: BoardDetailView,
                layout: LayoutView,
            },
        ],
    },
];
export default routes;
